import React from 'react';

export const Footer: React.FC = () => (
	<div className="h-[450px] w-full p-2 bg-[#191919] text-white text-center">
		<span>©2022 ADAC</span>
	</div>
);
